import {
  PLACEMENT__BOTTOM_END
} from '../components/Layout/Wrappers/StyledTooltip';
import {
  ENGAGEMENT_MATCH_STRENGTH__NO,
  ENGAGEMENT_MATCH_STRENGTH__STRONG_NO,
  ENGAGEMENT_MATCH_STRENGTH__STRONG_YES,
  ENGAGEMENT_MATCH_STRENGTH__TBD,
  ENGAGEMENT_MATCH_STRENGTH__WEAK_NO,
  ENGAGEMENT_MATCH_STRENGTH__WEAK_YES,
  ENGAGEMENT_MATCH_STRENGTH__YES
} from '../lib/Definition';

const MatchPageUI = {
  SelectedJobExtendedFilter: {
    label: 'Extended Filter',
    title: 'Enable extended filters: Rating and Stages',
    placement: PLACEMENT__BOTTOM_END
  },
  JobsDropdown: {
    label: 'Jobs',
    title: 'Select a similar job to filter candidates matched to that role',
    placement: PLACEMENT__BOTTOM_END,
  },
  // camelcase and start with uppercase to define component dictionaries
  // camelcase and start with lowercase to define key dictionaries and variables
  CardChipBar: {
    JobStatus: {
      jobsPermitted: {
        label: 'Permitted',
        color: colors.red.darker
      },
      jobsPitched: {
        label: 'Awaiting',
        color: colors.red.darker
      },
      jobsDeclined: {
        label: 'Declined',
        color: colors.red.darker
      },
      jobBlackListed: {
        label: 'Blacklisted',
        color: colors.red.darker
      },
      candidateHired: {
        label: 'Hired',
        color: colors.red.darker
      },
      limitedRecruiter: {
        label: 'Limited',
        color: colors.red.darker
      }
    },
    matchType: {
      // The label comes from the tag system -> `matchType`:
      // 1. Recruiter Self Match
      // 2. ML Auto Catch Recruiter Miss
      // 3. Admin Additional Match
      // 4. Admin Back Match
      label: '{{LABEL__TAG__MATCH_TYPE}}',
      color: colors.orange.darker
    },
    OwnerShip: {
      // (MatchPage Logic) IF Job is blacklisted
      unavailableToCando: {
        label: 'UnavailableToCando',
        color: colors.red.dark
      },
      // (MatchPage Logic) ELSE OR any of following cases
      // Note: each color should different as they are used to evalute job permission statuses.
      ownedByOther: {
        label: 'OwnedByOther',
        color: colors.orange.darker  // TAKEN
      },
      tbdForOther: {
        label: 'TbdForOther',
        color: colors.gray.common  // TBD
      },
      ownedByNoOne: {
        label: 'OwnedByNoOne',
        color: colors.purple.common  // AVAILABLE
      },
      iAlreadyOwnIt: {
        label: 'iAlreadyOwnIt',
        color: colors.cyan.darker  // YOUR
      },
      iTbdItWithoutEngagement: {
        label: 'TbdForCando',
        color: colors.gray.common  // TBD
      },
      // (MatchPage Logic) END IF
      // (MatchPage Logic) PLUS prior submission
      priorSubmission: {
        // The label is built based on the calculation of prior submissions:
        // 1. Prior Submission*
        // 2. Prior Submission^
        label: '{{LABEL__CALCULATED__PRIOR_SUBMISSION}}',
        // The color is currently inherited from one of the above cases.
        color: '{{COLOR__CALCULATED__OWNERSHIP}}'
      },
      // (MatchPage Logic) PLUS calibration status
      // The calibration label is built based on `engagement.calibrationStatus`.
      calibration: {
        [ENGAGEMENT_MATCH_STRENGTH__YES]: {
          color: colors.green.darker
        },
        [ENGAGEMENT_MATCH_STRENGTH__WEAK_YES]: {
          color: colors.green.darker
        },
        [ENGAGEMENT_MATCH_STRENGTH__STRONG_YES]: {
          color: colors.green.darker
        },
        [ENGAGEMENT_MATCH_STRENGTH__NO]: {
          color: colors.red.darker
        },
        [ENGAGEMENT_MATCH_STRENGTH__WEAK_NO]: {
          color: colors.red.darker
        },
        [ENGAGEMENT_MATCH_STRENGTH__STRONG_NO]: {
          color: colors.red.darker
        },
        [ENGAGEMENT_MATCH_STRENGTH__TBD]: {
          color: colors.orange.darker
        }
      }
    }
  }
};
export default MatchPageUI;
